import {endpoint} from "@/utils/api/Conf";
import {WalkSegmentStatus} from "@/types/Walk";

export const segmentStatusRequest = async (authToken: string, pathId: string, segmentId: string): Promise<WalkSegmentStatus | false> => {
  try {
    const init: RequestInit = {
      method: "GET",
      headers: {
        'Authorization': `Bearer ${authToken}`,
      }
    }
    return await fetch(endpoint + `walk/status/${pathId}/${segmentId}`, init)
      .then((response) => response.json())
      .then((data: WalkSegmentStatus) => {
        return data
      });
  } catch (error) {
    console.error("An error occurred while fetching data: ", error);
    return false
  }
}

